/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
  selector: 'chat-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './chatInput.component.html',
  styleUrl: './chatInput.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInputComponent {
  @Output() keydownEvent = new EventEmitter<Event>();
  @Input() chatForm!: FormGroup;
  public dataChat = inject(DataChatService);
  public isStreaming = computed(() => this.dataChat.isStreaming())

  public inputText: any;

  public message = computed(() => {
    switch (this.dataChat.lang()) {
      case 'es': return 'Escribe un mensaje...'
      case 'en': return 'Write a message...'
      case 'fr': return 'Écris un message...'
      case 'it': return 'Scrivi un messaggio...'
      case 'de': return 'Schreibe eine Nachricht...'
      default: return 'Write a message...'
    }
  });

  onKeyPress() {
    this.dataChat.inputText.set(this.inputText)
  }

  // --- VISION AGENT / IMAGE UPLOAD ---
  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type.match(/image\/*/) == null) {
        // TODO: Show alert or toast
        return;
      }
      this.dataChat.selectedImage.set(file);

      const reader = new FileReader();
      reader.onload = (e) => {
        this.dataChat.imagePreviewUrl.set(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  }

  clearImage(evt) {
    evt.preventDefault()
    evt.stopPropagation();

    console.log("clearing image...", evt)
    this.dataChat.selectedImage.set(null);
    this.dataChat.imagePreviewUrl.set(null);
    // Reset file input
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  getUserInputControl(): FormControl {
    return this.chatForm?.get('userInput') as FormControl;
  }

  emitKeyDownEvent(event: Event) {
    console.log("EVENR:", event);
    this.keydownEvent.emit(event)
  }

}
